// import the cover images
import tedTalksImg from './assets/gallery/ted-talks.jpg';
import openingGalaImg from './assets/gallery/opening-gala.jpg';
import ideasAdventuresImg from './assets/gallery/ideas-adventures.jpeg';
import sideEventsImg from './assets/gallery/side-events.jpeg';
import liveDemosImg from './assets/gallery/live-demos.jpg';
import speakerMeetupsImg from './assets/gallery/speaker-meetups.jpg';
import discoverySessionsImg from './assets/gallery/discovery-sessions.jpg';
import breaksConnectionImg from './assets/gallery/breaks-connection.jpg';

// --- Category 1: TED Talks ---
// Import Drag Images
import cat1Drag1 from './assets/category1/drag/1.jpg';
import cat1Drag2 from './assets/category1/drag/2.jpg';
import cat1Drag3 from './assets/category1/drag/3.jpeg';
import cat1Drag4 from './assets/category1/drag/4.jpeg';
import cat1Drag5 from './assets/category1/drag/5.jpeg';
import cat1Drag6 from './assets/category1/drag/6.jpeg';
import cat1Drag7 from './assets/category1/drag/7.jpg';
import cat1Drag8 from './assets/category1/drag/8.jpg';
// Import Carousel Images
import cat1Car1 from './assets/category1/carousel/1.jpg';
import cat1Car2 from './assets/category1/carousel/2.jpg';
import cat1Car3 from './assets/category1/carousel/3.jpeg';
import cat1Car4 from './assets/category1/carousel/4.jpeg';
import cat1Car5 from './assets/category1/carousel/5.jpeg';
import cat1Car6 from './assets/category1/carousel/6.jpeg';
import cat1Car7 from './assets/category1/carousel/7.jpg';
import cat1Car8 from './assets/category1/carousel/8.jpg';

// --- Category 2: Opening Gala ---
// Import Drag Images
import cat2Drag1 from './assets/category2/drag/1.jpg';
import cat2Drag2 from './assets/category2/drag/2.jpeg';
import cat2Drag3 from './assets/category2/drag/3.jpeg';
import cat2Drag4 from './assets/category2/drag/4.jpeg';
import cat2Drag5 from './assets/category2/drag/5.jpeg';
import cat2Drag6 from './assets/category2/drag/6.jpeg';
import cat2Drag7 from './assets/category2/drag/7.jpeg';
import cat2Drag8 from './assets/category2/drag/8.jpeg';
// Import Carousel Images
import cat2Car1 from './assets/category2/carousel/1.jpg';
import cat2Car2 from './assets/category2/carousel/2.jpeg';
import cat2Car3 from './assets/category2/carousel/3.jpeg';
import cat2Car4 from './assets/category2/carousel/4.jpeg';
import cat2Car5 from './assets/category2/carousel/5.jpeg';
import cat2Car6 from './assets/category2/carousel/6.jpeg';
import cat2Car7 from './assets/category2/carousel/7.jpeg';
import cat2Car8 from './assets/category2/carousel/8.jpeg';
// --- Category 3: Ideas Adventures ---
// Import Drag Images
import cat3Drag1 from './assets/category3/drag/1.jpg';
import cat3Drag2 from './assets/category3/drag/2.jpg';
import cat3Drag3 from './assets/category3/drag/3.jpeg';
import cat3Drag4 from './assets/category3/drag/4.jpg';
import cat3Drag5 from './assets/category3/drag/5.jpg';
import cat3Drag6 from './assets/category3/drag/6.jpg';
import cat3Drag7 from './assets/category3/drag/7.jpeg';
import cat3Drag8 from './assets/category3/drag/8.jpeg';
// Import Carousel Images
import cat3Car1 from './assets/category3/carousel/1.jpg';
import cat3Car2 from './assets/category3/carousel/2.jpg';
import cat3Car3 from './assets/category3/carousel/3.jpeg';
import cat3Car4 from './assets/category3/carousel/4.jpg';
import cat3Car5 from './assets/category3/carousel/5.jpg';
import cat3Car6 from './assets/category3/carousel/6.jpg';
import cat3Car7 from './assets/category3/carousel/7.jpeg';
import cat3Car8 from './assets/category3/carousel/8.jpeg';

// --- Category 4: Side Events ---
// Import Drag Images
import cat4Drag1 from './assets/category4/drag/1.jpg';
import cat4Drag2 from './assets/category4/drag/2.jpeg';
import cat4Drag3 from './assets/category4/drag/3.jpeg';
import cat4Drag4 from './assets/category4/drag/4.jpeg';
import cat4Drag5 from './assets/category4/drag/5.jpeg';
import cat4Drag6 from './assets/category4/drag/6.jpeg';
import cat4Drag7 from './assets/category4/drag/7.jpeg';
import cat4Drag8 from './assets/category4/drag/8.jpeg';
// Import Carousel Images
import cat4Car1 from './assets/category4/carousel/1.jpg';
import cat4Car2 from './assets/category4/carousel/2.jpeg';
import cat4Car3 from './assets/category4/carousel/3.jpeg';
import cat4Car4 from './assets/category4/carousel/4.jpeg';
import cat4Car5 from './assets/category4/carousel/5.jpeg';
import cat4Car6 from './assets/category4/carousel/6.jpeg';
import cat4Car7 from './assets/category4/carousel/7.jpeg';
import cat4Car8 from './assets/category4/carousel/8.jpeg';

// Main Data Object
export const galleryData = [
  {
    id: 'ted-talks',
    label: 'TALKS',
    coverImage: tedTalksImg,
    
    // Specific images for the Drag Section of this card
    dragImages: [
      cat1Drag1, 
      cat1Drag2, 
      cat1Drag3,
      cat1Drag4,
      cat1Drag5,
      cat1Drag6,
      cat1Drag7,
      cat1Drag8
    ],

    // Specific images for the Carousel Section of this card
    carouselImages: [
      { id: 1, image: cat1Car1 },
      { id: 2, image: cat1Car2 },
      { id: 3, image: cat1Car3 },
      { id: 4, image: cat1Car4 },
      { id: 5, image: cat1Car5 },
      { id: 6, image: cat1Car6 },
      { id: 7, image: cat1Car7 },
      { id: 8, image: cat1Car8 },
    ]
  },
  {
    id: 'opening-gala',
    label: 'TEDxIITGuwahati 2026',
    coverImage: openingGalaImg,
    
    dragImages: [
      cat2Drag1, 
      cat2Drag2,
      cat2Drag3,
      cat2Drag4,
      cat2Drag5,
      cat2Drag6,
      cat2Drag7,
      cat2Drag8
    ],

    carouselImages: [
      { id: 1, image: cat2Car1 },
      { id: 2, image: cat2Car2 },
      { id: 3, image: cat2Car3 },
      { id: 4, image: cat2Car4 },
      { id: 5, image: cat2Car5 },
      { id: 6, image: cat2Car6 },
      { id: 7, image: cat2Car7 },
      { id: 8, image: cat2Car8 },
    ]
  },
    {
    id: 'ideas-adventures',
    label: 'Others',
    coverImage: ideasAdventuresImg,
    
    dragImages: [
      cat3Drag1, 
      cat3Drag2,
      cat3Drag3,
      cat3Drag4,
      cat3Drag5,
      cat3Drag6,
      cat3Drag7,
      cat3Drag8
    ],

    carouselImages: [
      { id: 1, image: cat3Car1 },
      { id: 2, image: cat3Car2 },
      { id: 3, image: cat3Car3 },
      { id: 4, image: cat3Car4 },
      { id: 5, image: cat3Car5 },
      { id: 6, image: cat3Car6 },
      { id: 7, image: cat3Car7 },
      { id: 8, image: cat3Car8 },
    ]
  },
   {
    id: 'side-events',
    label: 'Friendship Fiesta',
    coverImage: sideEventsImg,
    
    dragImages: [
      cat4Drag1, 
      cat4Drag2,
      cat4Drag3,
      cat4Drag4,
      cat4Drag5,
      cat4Drag6,
      cat4Drag7,
      cat4Drag8
    ],

    carouselImages: [
      { id: 1, image: cat4Car1 },
      { id: 2, image: cat4Car2 },
      { id: 3, image: cat4Car3 },
      { id: 4, image: cat4Car4 },
      { id: 5, image: cat4Car5 },
      { id: 6, image: cat4Car6 },
      { id: 7, image: cat4Car7 },
      { id: 8, image: cat4Car8 },
    ]
  },
];